import React from 'react';
import { prepareDoctorName } from 'infrastructure/functions';
import CopyableText from 'components/atoms/buttons/copyable-text';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';

import s from './styles.module.scss';

import type { ISmsCampaignAnswer } from 'infrastructure/interfaces';

interface IProps {
  data: ISmsCampaignAnswer;
}

const PatientName: React.FC<IProps> = ({ data }) => {
  const fullName = prepareDoctorName({
    firstName: data.firstName,
    lastName: data.lastName,
    title: data.title,
  });

  return (
    <div className={s.name}>
      <Link to={Routes.patientGuid(data.guid)}>{fullName}</Link>
      <CopyableText className={s.copy} value={data.guid}>
        {data.guid}
      </CopyableText>
    </div>
  );
};

export default PatientName;
